import React from 'react'
import { css } from '@emotion/react'
import { A } from '../atoms/A'
import { colors } from 'plume-ui'
import Link, { LinkProps } from 'next/link'

type Props = {
  isHidden: boolean
  count?: number
  prefetch?: boolean
  dataTestId?: string
} & LinkProps

export const ViewMoreLink: React.FC<Props> = (props) => {
  // NOTE: props.onClickを渡すと、Hrefでの遷移はなくなる
  if (props.isHidden) {
    return null
  }

  const { prefetch = true } = props

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        background-color: ${colors.white10};
        padding-block: 21px;
        font-size: 14px;
        line-height: 1;
      `}
      data-test-id={props.dataTestId}
    >
      <Link href={props.href} as={props.as} prefetch={prefetch} passHref>
        <A
          decoration="none"
          css={css`
            display: flex;
            align-items: center;
          `}
          onClick={props.onClick}
          data-testid="view-more-link"
          target="_blank"
        >
          もっと見る
          {props.count && (
            <span css={css``}>
              &nbsp;（<span data-testid="view-more-count">{props.count}</span>）
            </span>
          )}
        </A>
      </Link>
    </div>
  )
}
